export const pageName = 'backupAndStorage';
export const SERVER_ADDRESS_REGEX = '(^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$)|((?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{1,63}(?<!-)\\.)+[a-zA-Z]{2,63}\\.?$))';
export const LOCAL_MOUNT_POINT_REGEX = '^/';
export const SNAPSHOT_NAME_REGEX = '^[a-zA-Z0-9_]*$';
export const NEGATIVE_TTL_REGEX = '^[1-9][0-9]*$';
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["CONFIGURED"] = "configStatus.configured";
    TranslationsKeys["UNCONFIGURED"] = "configStatus.notConfigured";
    TranslationsKeys["MESSAGE_API_FAILURE"] = "smtp.message.apiFailure";
    TranslationsKeys["MESSAGE_SAVE_FAILURE"] = "smtp.message.saveFailure";
    TranslationsKeys["SAVE_BUTTON"] = "smtp.actions.save";
    TranslationsKeys["EDIT_BUTTON"] = "smtp.actions.edit";
    TranslationsKeys["CONFIGURE_BUTTON"] = "smtp.actions.configure";
    TranslationsKeys["CANCEL_BUTTON"] = "smtp.actions.cancel";
    TranslationsKeys["TOAST_SUCCESS"] = "tscli.ui.datasave.success.message";
    TranslationsKeys["MOUNT_TYPE"] = "nas.modal.mountTitle";
    TranslationsKeys["NFS"] = "nas.modal.mountType.nfs";
    TranslationsKeys["CIFS"] = "nas.modal.mountType.cifs";
    TranslationsKeys["NONE_SELECTED_MOUNT_TYPE_REQUIRED"] = "error.nas.noneSelectedMountTypeRequired";
    TranslationsKeys["ADMIN_SECTION_BACKUP_NAS"] = "adminSection.backup.nas";
    TranslationsKeys["CONFIG_STATUS_NOT_CONFIGURED"] = "configStatus.notConfigured";
    TranslationsKeys["SNAPSHOT_TITLE"] = "snapshot.title";
    TranslationsKeys["SERVER_ADDRESS"] = "nas.modal.serverAddress";
    TranslationsKeys["SERVER_ADDRESS_REGEX_ERROR"] = "error.nas.validServerAddress";
    TranslationsKeys["PATH_ON_SERVER"] = "nas.modal.pathOnServer";
    TranslationsKeys["LOCAL_MOUNT_POINT"] = "nas.modal.localMountPoint";
    TranslationsKeys["LOCAL_MOUNT_POINT_REGEX_ERROR"] = "error.nas.localMountPointStartWithSlash";
    TranslationsKeys["OPTIONAL_MOUNT_PARAMETERS"] = "nas.modal.optionalMountParameters";
    TranslationsKeys["USERNAME_LABEL"] = "smtp.form.username";
    TranslationsKeys["PASSWORD_LABEL"] = "smtp.form.password";
    TranslationsKeys["SNAPSHOT_FORM_LABEL_FOR_NAME"] = "snapshot.modal.snapshotName.title";
    TranslationsKeys["SNAPSHOT_NAME_REQUIRED"] = "error.snapshot.snapshotName";
    TranslationsKeys["SNAPSHOT_REGEX_ERROR"] = "error.snapshot.specialCharactersError";
    TranslationsKeys["TTL_LABEL"] = "snapshot.modal.timeToLive.title";
    TranslationsKeys["TTL_REQUIRED"] = "error.snapshot.snapshotTimeToLive";
    TranslationsKeys["TTL_REGEX_ERROR"] = "error.snapshot.negativeTimeToLiveError";
    TranslationsKeys["BACKUPANDSTORAGE_TITLE"] = "system.backupStorage.title";
    TranslationsKeys["BACKUPANDSTORAGE_DESCRIPTION"] = "system.backupStorage.description";
    TranslationsKeys["MOUNT_POINT_NAS_HEADING"] = "system.backupStorage.mountPointInNasHeading.title";
    TranslationsKeys["MOUNT_POINT_NAS_DESCRIPTION"] = "system.backupStorage.mountPointInNasHeading.description";
    TranslationsKeys["SNAPSHOT_DESCRIPTION"] = "system.backupStorage.snapshotHeading.description";
    TranslationsKeys["NAS_MODAL_CONTENT"] = "nas.modal.content";
    TranslationsKeys["NAS_MODAL_TITLE"] = "nas.modal.title";
    TranslationsKeys["SNAPSHOT_MODAL_CONTENT"] = "snapshot.modal.content";
    TranslationsKeys["SNAPSHOT_MODAL_TITLE"] = "snapshot.modal.title";
    TranslationsKeys["NAS_NO_CONFIG_TITLE"] = "configStatus.nas.label";
    TranslationsKeys["NAS_NO_CONFIG_CONTENT"] = "configStatus.notConfigured";
    TranslationsKeys["SNAPSHOT_NO_CONFIG_TITLE"] = "configStatus.snapshot.label";
    TranslationsKeys["SNAPSHOT_NO_CONFIG_CONTENT"] = "configStatus.snapshot.status";
    TranslationsKeys["VALID_FIELDNAME"] = "smtp.valid.fieldName";
    TranslationsKeys["NAS_CONFIGSTATUS_LABEL"] = "system.backupStorage.nas.configurationStatusLabel";
    TranslationsKeys["NAS_NOT_CONFIGURED"] = "system.backupStorage.nas.notConfigured";
    TranslationsKeys["SNAPSHOT_CONFIGSTATUS_LABEL"] = "system.backupStorage.snapshot.configurationStatusLabel";
    TranslationsKeys["SNAPSHOT_NOT_CREATED"] = "system.backupStorage.snapshot.notConfigured";
    TranslationsKeys["NAS_FORMEDIT_TITLE"] = "system.backupStorage.nasMount.formEditTitle";
    TranslationsKeys["SNAPSHOT_DUPLICATE_NAME_ERROR"] = "error.snapshot.duplicateNameError";
    TranslationsKeys["SNAPSHOT_DELETED"] = "system.backupStorage.snapshot.delete.success";
    TranslationsKeys["NAS_DELETED"] = "system.backupStorage.nas.delete.success";
    TranslationsKeys["STATUS"] = "adminSection.scheduleMaintenance.tableHeader.status";
    TranslationsKeys["HELP_TEXT_FOR_SNAPSHOT_NAME"] = "system.snapshotForm.name.helpText";
    TranslationsKeys["HELP_TEXT_FOR_OPTIONS"] = "system.nasForm.optionalField.helpText";
    TranslationsKeys["LEARN_MORE"] = "LEARN_MORE";
    TranslationsKeys["OPTIONAL"] = "system.nasForm.mountParam.optionalText";
    TranslationsKeys["CHECK_LATER_TITLE"] = "system.snapshotTable.status.checkLaterTitle";
    TranslationsKeys["CHECK_LATER_BODY"] = "system.snapshotTable.status.checkLaterBody";
    TranslationsKeys["CHECK_LATER_CTA"] = "gotIt";
})(TranslationsKeys || (TranslationsKeys = {}));
export var Action;
(function (Action) {
    Action[Action["EMPTY_NAS"] = 0] = "EMPTY_NAS";
    Action[Action["EMPTY_SNAPSHOT"] = 1] = "EMPTY_SNAPSHOT";
    Action[Action["FILL_SNAPSHOT_FORM"] = 2] = "FILL_SNAPSHOT_FORM";
    Action[Action["FILL_NAS_FORM"] = 3] = "FILL_NAS_FORM";
    Action[Action["VALIDATE_SNAPSHOT_FORM_DUPLICATE_NAME"] = 4] = "VALIDATE_SNAPSHOT_FORM_DUPLICATE_NAME";
    Action[Action["ADD_USERNAME_PASSWORD"] = 5] = "ADD_USERNAME_PASSWORD";
    Action[Action["REMOVE_USERNAME_PASSWORD"] = 6] = "REMOVE_USERNAME_PASSWORD";
    Action[Action["RESET_NAS_FORM"] = 7] = "RESET_NAS_FORM";
    Action[Action["RESET_SNAPSHOT_FORM"] = 8] = "RESET_SNAPSHOT_FORM";
    Action[Action["NOT_EMPTY_NAS"] = 9] = "NOT_EMPTY_NAS";
})(Action || (Action = {}));
export var mountType;
(function (mountType) {
    mountType["NFS"] = "nfs";
    mountType["CIFS"] = "cifs";
})(mountType || (mountType = {}));
export var SnapshotStatus;
(function (SnapshotStatus) {
    SnapshotStatus["SNAPSHOT_NOT_FOUND"] = "system.backupStorage.snapshotTable.status.notFound";
    SnapshotStatus["SNAPSHOT_CREATE_STARTED"] = "system.backupStorage.status.inProgress";
    SnapshotStatus["SNAPSHOT_CREATE_FINISHED"] = "system.backupStorage.snapshotTable.status.created";
    SnapshotStatus["SNAPSHOT_CREATE_FAILED"] = "system.snapshotTable.status.createFailed";
    SnapshotStatus["SNAPSHOT_DELETE_SCHEDULED"] = "system.snapshotTable.status.deleteScheduled";
    SnapshotStatus["SNAPSHOT_DELETE_FAILED"] = "system.snapshotTable.status.deleteFailed";
})(SnapshotStatus || (SnapshotStatus = {}));
export var NasStatus;
(function (NasStatus) {
    NasStatus["EMPTY"] = "system.backupStorage.status.error";
    NasStatus["NOT_CONFIGURED"] = "system.backupStorage.status.inProgress";
    NasStatus["CONFIGURED"] = "system.backupStorage.nasTable.status.configured";
})(NasStatus || (NasStatus = {}));
export var BackupAndStorageType;
(function (BackupAndStorageType) {
    BackupAndStorageType["NAS"] = "nas";
    BackupAndStorageType["SNAPSHOT"] = "snapshot";
})(BackupAndStorageType || (BackupAndStorageType = {}));
//# sourceMappingURL=constants.js.map